import {
  inferFamilyValueFromColumnName,
  isSheetPrimaryFamily,
  normalizeMaskFamilyValue,
} from '../../../Config/hcp-mask-families'
import { getProdutoConfig, TIRAGEM_MINIMA_PADRAO } from '../../../Config/hcp-print-run-config'
import { IHCPFlowKanbanColumn } from './hcp-flow.interface'
import { IHCPFlowKanbanCard } from './hcp-flow-card.interface'

export const SHEET_DIVERSOS_STATUS_ID = '__sheet_diversos__'

export function resolveColumnFamilyValue(
  column: Pick<IHCPFlowKanbanColumn, 'name' | 'sheetRule'>
): string | null {
  const fromRule = normalizeMaskFamilyValue(column.sheetRule?.familyValue)
  if (fromRule) return fromRule

  return inferFamilyValueFromColumnName(column.name)
}

/** Colunas com coluna própria no kanban (quando tiver cards), via família da máscara. */
export function isSheetPrimaryColumn(column: Pick<IHCPFlowKanbanColumn, 'name' | 'sheetRule'>): boolean {
  return isSheetPrimaryFamily(resolveColumnFamilyValue(column))
}

function sumTiragem(cards: IHCPFlowKanbanCard[]): number {
  return cards.reduce((acc, card) => acc + (Number(card.totalQuantity) || 0), 0)
}

function mergeCardsUnique(cardsLists: IHCPFlowKanbanCard[][]): IHCPFlowKanbanCard[] {
  const seen = new Set<string>()
  const merged: IHCPFlowKanbanCard[] = []

  cardsLists.forEach((cards) => {
    cards.forEach((card) => {
      const key = `${card.type ?? 'ITEM'}:${card.id}`
      if (seen.has(key)) return
      seen.add(key)
      merged.push(card)
    })
  })

  return merged
}

function buildDiversosColumn(
  sources: IHCPFlowKanbanColumn[],
  flowCode: number
): IHCPFlowKanbanColumn {
  const cards = mergeCardsUnique(sources.map((column) => column.cards))
  const hasNextPage = sources.some((column) => column.hasNextPage)
  const total = sources.reduce((acc, column) => Math.max(acc, column.total), cards.length)

  return {
    statusId: SHEET_DIVERSOS_STATUS_ID,
    flow: 'SHEET',
    flowCode,
    sequence: 99999,
    displayCode: `${flowCode}-DV`,
    name: 'Diversos',
    masterCode: null,
    isActive: true,
    page: 1,
    offset: 50,
    total: Math.max(total, cards.length),
    hasNextPage,
    cards,
}

/**
 */
}

/**
 * Layout Fluxo 2:
 * - Copo (CCP), Pote (PPT), Tampa selável (TSC/TSP): coluna individual
 * - Demais famílias de máscara: agrupadas em "Diversos"
 */
export function applySheetColumnLayout(columns: IHCPFlowKanbanColumn[]): IHCPFlowKanbanColumn[] {
  return [...columns].sort((a, b) => a.sequence - b.sequence)




}

export function getSheetColumnTiragem(column: IHCPFlowKanbanColumn): {
  total: number
  minimo: number
} {
  const total = sumTiragem(column.cards)
  const minimo = column.statusId === SHEET_DIVERSOS_STATUS_ID
    ? 0
    : getProdutoConfig(column.name).minimoCartela ?? TIRAGEM_MINIMA_PADRAO

  return { total, minimo }
}
